import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrBookingStatus.ts
var t = () => e("bookingStatus");
//#endregion
export { t as useTrBookingStatus };
